import React, { useState, useEffect } from "react";
import Confirmation from "./Confirmation";
import IPOCancel from "./IPOCancel";
import IPODetails from "./IPODetails";
import IPOListing from "./IPOListing";
import IPOModify from "./IPOModify";
import IPOSummary from "./IPOSummary";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Transactions from "../Transactions/Transaction";

const IPOIndex = ({indexPage=1,...props}) => {

  const routes = [
    '',
    '/details',
    '/summary',
    '/success',
    '/confirm-cancel',
    '/cancel',
    '/modify',
    '/transactions'
  ]

  const location = useLocation()
  const params = useParams()
  const currentPath = (location.pathname).split('/home/IPO')?.[1]
  
  console.log('path = ',currentPath)

  const navigate = useNavigate();
  const { state } = useLocation();
  // console.log(state);
  const [summaryData, setsummaryData] = useState(state);
  const [step, setstep] = useState(indexPage ? indexPage : 1);
  const [sendDetailstoIPODetails, setsendDetailstoIPODetails] = useState({
    MaxPrice:0,
    LotSize:1,
  });
  
  const needsReset = (!['','/transactions'].includes(currentPath)) && Object.keys(sendDetailstoIPODetails).length == 2

  const [prevOldPage, setprevOldPage] = useState("");
  let bidingDetails = [
    {
      id: 1,
      lotsize: sendDetailstoIPODetails.LotSize,
      cutoffprice: true,
      price: sendDetailstoIPODetails.MaxPrice,
      selectstatus: false,

      cart: {
        price: sendDetailstoIPODetails.MaxPrice,
        quantity: sendDetailstoIPODetails.LotSize,
        finalPrice: sendDetailstoIPODetails.MaxPrice,
        incBlock: false,
        decBlock: true,
      },
    },
  ];
  const [bidingUsestate, setbidingUsestate] = useState(bidingDetails);
  useEffect(() => {
    if(needsReset){
      navigate('/home/IPO')
    }
    if (state) {
      //set prev to come dashboard
      setprevOldPage("null");
      // setsendDetailstoIPODetails(state)
      setstep(3);
    }
  }, []);

  useEffect(()=>{
    if(indexPage){
      setstep(indexPage)
    }
  },[indexPage])

  const nextStep = () => {
    setstep(step + 1);
  };
  const prevStep = () => {
    setstep(step - 1);
  };

  const selectedIpoDetails = (e) => {
    setsendDetailstoIPODetails(e);
    if(state === null){
        let json = {
            summarydataname:e
        }
        setsummaryData(json);
      
       
    }     

  };

  const goToPage = (pageNO, datafromdetails, gotoTras) => {
    console.log(datafromdetails)
    console.log(gotoTras)
    if (gotoTras != true) {

        if(datafromdetails != undefined){
            let json = {
                summarydataname:datafromdetails
            }
            setsummaryData(json);

            let addFulldetails = datafromdetails;
            // console.log(addFulldetails)
            if(addFulldetails.BidingDetails){
              let bids = addFulldetails.BidingDetails.bids;
              let locbidingDetails = [];
              console.log(bids)
              for(let i=0;i<bids.length;i++){
                const bid = bids[i]
                locbidingDetails.push({
                            ...bid,
                            id:(i+1),
                            lotsize: addFulldetails.LotSize,

                            cutoffprice:bids[i].cutoff_flag == "Y"?true:false,
                            price: bids[i].price || addFulldetails.MaxPrice,
                            selectstatus:false,
                            cart:{
                                price: bids[i].price,
                                quantity: bids[i].quantity,
                                finalPrice: bids[i].amount,
                                incBlock: false, //can_cancel_flag
                                decBlock: true
                            }
                        })
                    }
                  
              setbidingUsestate(locbidingDetails);

            }else {
              setbidingUsestate(bidingDetails)
            }
            addFulldetails.Indetails =datafromdetails;
            setsendDetailstoIPODetails(addFulldetails);

        }
         
      //check this
      
      setprevOldPage(step);
      setstep(pageNO);
      if(pageNO != 3 || !!datafromdetails){
        let addFulldetails = sendDetailstoIPODetails;
        addFulldetails.Indetails = datafromdetails;
        setsendDetailstoIPODetails(addFulldetails);
      }
      navigate(`/home/IPO${routes[pageNO-1]}`)
    } else {
      navigate("/home/IPO/transactions");
    }
  };


  const renderIPOSubscription = () => {
    let step = routes.findIndex(r => r == currentPath) + 1 

    if(needsReset){step = 1}

    switch (step) {
      case 1:
        return (
          <IPOListing
            nextStep={nextStep}
            prevStep={prevStep}
            selectedIpoDetails={selectedIpoDetails}
            goToPage={goToPage}
          />
        );
      case 2:
        return (
          <IPODetails
            nextStep={nextStep}
            prevStep={prevStep}
            // ipoDetailsname={sendDetailstoIPODetails.Symbol}
            ipoDetailsname={summaryData?.summarydataname?.Symbol}
            goToPage={goToPage}
          />
        );
      case 3:
        return (
          <IPOSummary
            nextStep={nextStep}
            prevStep={prevStep}
            ipoDetails={sendDetailstoIPODetails}
            summaryData={summaryData}
            prevPage={prevOldPage}
            bidingDetail={bidingUsestate}
            goToPage={goToPage}
          />
        );
      case 4:
        return (
          <Confirmation
            nextStep={nextStep}
            prevStep={prevStep}
            ipoDetails={sendDetailstoIPODetails}
            summaryData={summaryData}
            status="success"
          />
        );
      case 5:
        return (
          <Confirmation
            nextStep={nextStep}
            prevStep={prevStep}
            ipoDetails={sendDetailstoIPODetails}
            status="cancel"
          />
        );
      case 6:
        return (
          <IPOCancel
            nextStep={nextStep}
            prevStep={prevStep}
            ipoDetails={sendDetailstoIPODetails}
            status="cancel"
            bidingDetail={bidingUsestate}
            goToPage={goToPage}
          />
        );
      case 7:
        return (
          <IPOModify
            nextStep={nextStep}
            prevStep={prevStep}
            ipoDetails={sendDetailstoIPODetails}
            status="modify"
            bidingDetail={bidingUsestate}
            goToPage={goToPage}
          />
        );
      case 8:
        return (
          <Transactions
            nextStep={nextStep}
            prevStep={prevStep}
            goToPage={goToPage}
            selectedIpoDetails={selectedIpoDetails}

            ipoDetails={sendDetailstoIPODetails}
            status="modify"
            bidingDetail={bidingUsestate}
          />
        );
    }
  };

  return (
    <div className="row">
      <div className="col-lg-12 col-md-12 col-12">
        <nav aria-label="breadcrumb" className="hide-md">
          <ol className="breadcrumb--UnorderList">
            <li className="breadcrumb-item">
              <a className="breadcrums">Login</a>
            </li>
            <p className="breadcrumb--Arrow">{">>"}</p>
            <li className="breadcrumb-item" aria-current="page">
              <a className="breadcrums"> Dashboard</a>
            </li>
            <p className="breadcrumb--Arrow">{">>"}</p>
            <li className="breadcrumb-itemActive" aria-current="page">
              IPO Listing
            </li>
          </ol>
        </nav>
      </div>

      <div className="col-lg-12 col-md-12 col-12">
        {renderIPOSubscription()}
      </div>
    </div>
  );
};

export default IPOIndex;
